<script  lang="ts">
  import { type User, EditUserDTO, ApiResultOfPublicUserDTO, AuthenticatedRequestOfEditUserDTO } from "@frontend/walletapi";
  import { service } from "@frontend/services";
  import { translate, currentLanguage } from "../Translator";
  import { GetCachedToken } from "@frontend/user";
 
  export let player: User;
  export let dismiss: () => void;

  let result: ApiResultOfPublicUserDTO | undefined = undefined;
  let editUser: EditUserDTO = {
    Id: player.Id,
    Email: player.Email,
    PhoneNumber: player.PhoneNumber,
    FirstName: player.FirstName,
    LastName: player.LastName,
    Enabled: player.Enabled,
    CountryCode: player.CountryCode,
    CurrencyCode: player.CurrencyCode,
    Reference: player.Reference,
    Txlimit: player.Txlimit,
    NewPassword: undefined
  }

  let showPasswordInput = false;
  let newPasswordValue: string | undefined = undefined;

  async function EditAdmin() {
    // Actualizar el NewPassword solo si estamos cambiando la contraseña
    if (showPasswordInput && newPasswordValue) {
      editUser.NewPassword = newPasswordValue;
    } else {
      editUser.NewPassword = undefined;
    }

    const requestPayload: AuthenticatedRequestOfEditUserDTO = {
      Token: GetCachedToken(), 
      Data: editUser, 
    };

    try {
      result = await service.walletapi.editUser(requestPayload); 
      if (result?.Success) {
        console.log('Usuario editado con éxito:', result);
        // Cerrar el modal después de un breve delay para mostrar el mensaje de éxito
        setTimeout(() => {
          dismiss();
        }, 1500);
      }
    } catch (error) {
      console.error('Error al editar el usuario:', error);
      result = {
        Success: false,
        Message: 'Error al editar el usuario',
        Data: undefined,
        ErrorMessage: 'Error al editar el usuario'
      };
    }
  }
</script>

<div class="edit-admin-container">
  <h2 class="ui centered dividing header">{$translate('Edit Admin')} #{editUser.Id}</h2>
  
  {#if result && result.Success && result.Data}
    <div class="ui positive message">
      <div class="header">{$translate('Edited successfully')}</div>
    </div>

    <div class="ui segment">
      <table class="receit-table">
        <tr><td class="receit-title">{$translate('Id')}</td><td class="receit-value">#{result.Data.Id}</td></tr>
        <tr><td class="receit-title">{$translate('First Name')}</td><td class="receit-value">{result.Data.FirstName} {result.Data.LastName}</td></tr>
        <tr><td class="receit-title">{$translate('E-mail')}</td><td class="receit-value">{result.Data.Email ?? ""}</td></tr>
        <tr><td class="receit-title">{$translate('Phone Number')}</td><td class="receit-value">{result.Data.PhoneNumber ?? ""}</td></tr>
        <tr><td class="receit-title">{$translate('Referral')}</td><td class="receit-value">{result.Data.Reference ?? ""}</td></tr>
        <tr><td class="receit-title">{$translate('Currency Code')}{$translate('Country')}</td><td class="receit-value">{result.Data.CountryCode}/{result.Data.CurrencyCode}</td></tr>
      </table>
    </div>

    <div class="button-group">
      <button class="ui primary button" on:click={dismiss}>{$translate('Dismiss')}</button>
      <button class="ui button">{$translate('Print')}</button>
    </div>
  {:else}
    {#if result && !result.Success}
      <div class="ui negative message">
        <div class="header">Error</div>
        <p>{result.ErrorMessage ?? "Unknown error when editing admin"}</p>
      </div>
    {/if}

    <form class="ui form" on:submit|preventDefault={EditAdmin}>
      <div class="two fields">
        <div class="field">
          <label>{$translate('First Name')}</label>
          <input type="text" placeholder="First name" bind:value={editUser.FirstName} required/>
        </div>
        <div class="field">
          <label>{$translate('Last Name')}</label>
          <input type="text" placeholder="Last name" bind:value={editUser.LastName} required/>
        </div>
      </div>

      <div class="two fields">
        <div class="field">
          <label>{$translate('E-mail')}</label>
          <input type="email" placeholder="Email" bind:value={editUser.Email}/>
        </div>
        <div class="field">
          <label>{$translate('Phone Number')}</label>
          <input type="tel" placeholder="Phone number" bind:value={editUser.PhoneNumber}/>
        </div>
      </div>

      <div class="three fields">
        <div class="field">
          <label>{$translate('Country')}</label>
          <input type="text" placeholder="Country code" bind:value={editUser.CountryCode}/>
        </div>
        <div class="field">
          <label>{  $translate('Currency Code')}</label>
          <input type="text" placeholder="Currency code" bind:value={editUser.CurrencyCode}/>
        </div>
        <div class="field">
          <label>{  $translate('Referral')}</label>
          <input style="background-color: green; color: darkblue;" type="text" placeholder="Reference" bind:value={editUser.Reference} readonly/>
        </div>
      </div>

      <div class="field">
        <label>{$translate('Password')}</label>
        <div class="password-section">
          <div class="ui buttons fluid">
            <button class="ui {!showPasswordInput ? 'positive' : ''} button" 
                    on:click|preventDefault={() => {
                      showPasswordInput = false;
                      newPasswordValue = undefined;
                      editUser.NewPassword = undefined;
                    }}>
              <i class="lock icon"></i>
              {$translate('Keep current password')}
            </button>
            <button class="ui {showPasswordInput ? 'positive' : ''} button" 
                    on:click|preventDefault={() => {
                      showPasswordInput = true;
                    }}>
              <i class="key icon"></i>
              {$translate('Set new password')}
            </button>
          </div>
          {#if showPasswordInput}
            <div class="ui fluid input" style="margin-top: 0.5rem;">
              <input 
                type="text" 
                placeholder="Enter new password" 
                bind:value={newPasswordValue}
                required={showPasswordInput}
              />
            </div>
          {/if}
        </div>
      </div> 

      <div class="button-group">
        <button class="ui negative button" on:click|preventDefault={dismiss}>Cancel</button>
        <button class="ui positive button" type="submit">{$translate('Save')}</button>
      </div>
    </form>
  {/if}
</div>

<style>
  .edit-admin-container {
    max-width: 600px;
    margin: 0 auto;
    padding: 1rem;
  }

  .button-group {
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
    margin-top: 1rem;
  }

  .password-section {
    display: flex;
    flex-direction: column;
  }

  .receit-table {
    width: 100%;
    border-spacing: 0;
    font-family: 'Courier New', Courier, monospace;
  }

  .receit-table td {
    padding: 0.5rem 0;
    border-bottom: 1px solid #eee;
  }

  .receit-title {
    text-align: left;
    padding-right: 1rem;
    color: #666;
  }

  .receit-value {
    text-align: right;
    font-weight: 500;
  }

  :global(.ui.form .field > label) {
    font-weight: 500;
    margin-bottom: 0.5rem;
  }

  :global(.ui.form input) {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 0.5rem;
  }
</style>
